import { Link, NavLink } from 'react-router-dom';
import { MdOutlineDarkMode } from 'react-icons/md';
import { useModalContext } from '../../context/modal-context';
import { topics } from './config';

// Reuses the portfolio navbar styles (nav / nav__container / nav__menu /
// #theme__icon from navbar.css) so the blog nav matches the main site.
const BlogHeader = () => {
  const { showModalHandler } = useModalContext();

  return (
    <nav className="blog-topnav">
      <div className="container nav__container">
        <ul className="nav__menu">
          <li>
            <NavLink to="/blog" end>All</NavLink>
          </li>
          {topics.map((t) => (
            <li key={t.slug}>
              <NavLink to={`/blog/topic/${t.slug}`}>{t.name}</NavLink>
            </li>
          ))}
          <li>
            <Link to="/" className="blog-nav__portfolio">Portfolio</Link>
          </li>
        </ul>
        <button
          id="theme__icon"
          onClick={showModalHandler}
          aria-label="Change appearance"
        >
          <MdOutlineDarkMode />
        </button>
      </div>
    </nav>
  );
};

export default BlogHeader;
